import { IOperation } from './i-operation';
import { MetaElementUsageIdentityVO, TextValueVO } from '../../vo/meta-element.vo';
import { ArticleContainerUtils } from '@3d-scene/model3d/util/article-container-utils';

export class UndoApplyTextOperation implements IOperation {
  constructor(
    private _textureAreaUsageIdentity: MetaElementUsageIdentityVO,
    private _originalTextValue: TextValueVO,
    private _newTextValue: TextValueVO,
    private _articleContainerUtils: ArticleContainerUtils
  ) {}

  public getQualifiedClassName(): string {
    return 'UndoApplyTextOperation';
  }

  public getOperationDescription(): string {
    return '';
  }

  public async performRedo(): Promise<void> {
    this.applyText(this._textureAreaUsageIdentity, this._newTextValue);
  }

  public async performUndo(): Promise<void> {
    this.applyText(this._textureAreaUsageIdentity, this._originalTextValue);
  }

  private applyText(textureAreaUsageIdentity: MetaElementUsageIdentityVO, textValue: TextValueVO): void {
    this._articleContainerUtils.applyTextToTextureAreaUsage(textureAreaUsageIdentity, textValue);
  }
}
